/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import "./ArtworkHistoryNotification.scss";

export default function ArtworkHistoryNotification({ children, ...restProps }: any) {
  return (
    <div
      {...restProps}
      className={cn("artwork-history-notification scope-f601efaf", restProps.className)}
    >
      <UseSvg
        className="artwork-history-notification__icon scope-f601efaf"
        icon="info-circle-bold"
        data-testid="artwork-history-notification-icon"
      />
      <div className="artwork-history-notification__message scope-f601efaf">{children}</div>
    </div>
  );
}
